import { FormattedMessage } from 'react-intl';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import { subscriptionsMessages } from 'src/features/subscriptions/utils/messages';
import { financialDocumentsMessages } from 'src/features/financialDocuments/utils/messages';
import { chargesMessages } from 'src/features/charges/utils/messages';
import { paymentsMessages } from 'src/features/payments/utils/messages';
import { paymentMethodsMessages } from 'src/features/paymentMethods/utils/messages';
import CustomerPaymentMethodsTable from 'src/features/paymentMethods/components/tables/CustomerPaymentMethodsTable';
import PaymentsTable from 'src/features/payments/components/tables/PaymentsTable';
import FinancialDocumentsTable from 'src/features/financialDocuments/components/tables/FinancialDocumentsTable';
import SubscriptionsTable from 'src/features/subscriptions/components/tables/SubscriptionsTable';
import ChargesTable from 'src/features/charges/components/tables/ChargesTable';
import { voucherTypesMessages } from 'src/features/voucherTypes/utils/messages';
import VouchersTable from 'src/features/vouchers/components/tables/VouchersTable';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

const CustomerDashboardTables = () => {
    const permissionAccessSubscriptions = useHasPermissions([PERMISSION.ACCESS_SUBSCRIPTIONS]);
    const permissionAccessFinancialDocuments = useHasPermissions([PERMISSION.ACCESS_FINANCIAL_DOCUMENTS]);
    const permissionAccessCharges = useHasPermissions([PERMISSION.ACCESS_CHARGES]);
    const permissionAccessPayments = useHasPermissions([PERMISSION.ACCESS_PAYMENTS]);
    const permissionAccessVouchers = useHasPermissions([PERMISSION.ACCESS_VOUCHERS]);

    const showTabsAndTables =
        permissionAccessSubscriptions ||
        permissionAccessFinancialDocuments ||
        permissionAccessCharges ||
        permissionAccessVouchers ||
        permissionAccessPayments;

    const defaultTabValue = (() => {
        if (permissionAccessSubscriptions) return 'subscriptions';
        if (permissionAccessFinancialDocuments) return 'financial-documents';
        if (permissionAccessCharges) return 'charges';
        if (permissionAccessPayments) return 'payments';
        if (permissionAccessVouchers) return 'vouchers';
    })();

    return (
        <div className="grid flex-3 grid-cols-1 pr-8">
            {showTabsAndTables && (
                <Tabs defaultValue={defaultTabValue}>
                    <TabsList>
                        {permissionAccessSubscriptions && (
                            <TabsTrigger value="subscriptions">
                                <FormattedMessage {...subscriptionsMessages.subscriptions} />
                            </TabsTrigger>
                        )}
                        {permissionAccessFinancialDocuments && (
                            <TabsTrigger value="financial-documents">
                                <FormattedMessage {...financialDocumentsMessages.financialDocuments} />
                            </TabsTrigger>
                        )}
                        {permissionAccessCharges && (
                            <TabsTrigger value="charges">
                                <FormattedMessage {...chargesMessages.charges} />
                            </TabsTrigger>
                        )}
                        {permissionAccessPayments && (
                            <>
                                <TabsTrigger value="payments">
                                    <FormattedMessage {...paymentsMessages.payments} />
                                </TabsTrigger>
                                <TabsTrigger value="payment-methods">
                                    <FormattedMessage {...paymentMethodsMessages.paymentMethods} />
                                </TabsTrigger>
                            </>
                        )}
                        {permissionAccessVouchers && (
                            <TabsTrigger value="vouchers">
                                <FormattedMessage {...voucherTypesMessages.vouchers} />
                            </TabsTrigger>
                        )}
                    </TabsList>

                    {permissionAccessSubscriptions && (
                        <TabsContent value="subscriptions">
                            <SubscriptionsTable />
                        </TabsContent>
                    )}
                    {permissionAccessFinancialDocuments && (
                        <TabsContent value="financial-documents">
                            <FinancialDocumentsTable />
                        </TabsContent>
                    )}

                    {permissionAccessCharges && (
                        <TabsContent value="charges">
                            <ChargesTable />
                        </TabsContent>
                    )}
                    {permissionAccessPayments && (
                        <>
                            <TabsContent value="payments">
                                <PaymentsTable />
                            </TabsContent>
                            <TabsContent value="payment-methods">
                                <CustomerPaymentMethodsTable />
                            </TabsContent>
                        </>
                    )}
                    {permissionAccessVouchers && (
                        <TabsContent value="vouchers">
                            <VouchersTable />
                        </TabsContent>
                    )}
                </Tabs>
            )}
        </div>
    );
};

export default CustomerDashboardTables;
